/**
 * Beschriftungen der Störungsliste. Sie gehören zum gemeinsamen Baustein, nicht in die Apps —
 * sonst zeigt ein Produkt, das ihn neu einbindet, rohe englische Schlüssel.
 *
 * Abweichende Werte bleiben trotzdem möglich: Die Apps mergen dieses Wörterbuch zuoberst, ihre
 * eigenen Schlüssel gewinnen. Genutzt wird das bei „Releasing a block does not restart anything" —
 * was eine Freigabe konkret bewirkt, hängt vom Produkt ab.
 */
export const sharedAdminFailureCircuitDe = {
  "Show resolved": "gelöste anzeigen",
  "Open system log": "Systemprotokoll ansehen",
  // Fragmentarische Beschriftungen sind keine Sätze: Ein einleitendes Adjektiv oder
  // Indefinitpronomen bleibt klein, auch als Kartentitel.
  "Blocked failure sources": "Störungen",
  "No blocked failure sources": "keine Störungen",
  "Tenant access problems": "Zugänge der Mandanten",
  "No tenant access problems": "keine angehaltenen Zugänge",
  "Failure class": "Ursache",
  Responsible: "zuständig",
  "Next attempt": "nächster Versuch",
  "Check now": "jetzt prüfen",
  "Check requested": "Der nächste Anlauf wird sofort geprüft.",
  "Failed to check failure circuit": "Die Prüfung konnte nicht angestoßen werden.",
  "Several tenants": "mehrere Mandanten",
  Responsibility_automatic: "automatisch",
  Responsibility_tenant: "Mandant",
  Responsibility_operator: "Betreiber",
  FailureCause_unreachable: "nicht erreichbar",
  FailureCause_throttled: "gedrosselt",
  FailureCause_access: "Zugang",
  FailureCause_funds: "Guthaben",
  FailureCause_deterministic: "reproduzierbar",
  FailureCause_internal: "unsere Seite",
  Failures: "Fehlschläge",
  "Suppressed attempts": "verhinderte Anläufe",
  "First failure": "erster Fehlschlag",
  "Last failure": "letzter Fehlschlag",
  "Blocked since": "gesperrt seit",
  "Blocked until": "gesperrt bis",
  "Blocked indefinitely": "bis zur Freigabe",
  Release: "freigeben",
  "Release block": "Sperre aufheben?",
  "Releasing a block does not restart anything":
    "Eine Freigabe startet nichts nach: Erst der nächste reguläre Anlauf läuft wieder.",
  "Failure circuit released": "Sperre aufgehoben.",
  "Resolved incidents deleted": "behobene Störungen gelöscht.",
  FailureClass_hard: "hart",
  FailureClass_system: "System",
  FailureClass_tenant_action: "Mandantensache",
  FailureClass_transient: "vorübergehend",
  "Failed to load failure circuits": "Gesperrte Fehlerquellen konnten nicht geladen werden.",
  "Failed to release failure circuit": "Die Sperre konnte nicht aufgehoben werden.",
  "Failed to delete resolved incidents": "behobene Störungen konnten nicht gelöscht werden.",
  Problem: "Problem",
  "No details recorded": "keine Angaben erfasst",
  "Error kind": "Fehlerart",
  Notification: "Betreibermeldung",
  "Notification pending": "steht aus",
  "Notification not applicable": "nicht vorgesehen",
  "Notification sent": "versandt",
  "Failure source": "Fehlerquelle",
  "Scope key": "Bereichsschlüssel",
  "Failure description": "Beschreibung",
  "Technical error": "technischer Fehler",
  "Open tenant": "Mandant ansehen",
  "Copy technical details": "technische Details kopieren",
  "Delete resolved incidents": "behobene Störungen löschen",
  "Delete resolved incidents?": "behobene Störungen löschen?",
  "All resolved incident records are deleted. Active incidents are retained and no source is restarted.":
    "Alle behobenen Störungseinträge werden gelöscht. Aktive Störungen bleiben erhalten und keine Quelle wird neu gestartet.",
  "All resolved technical incident records are deleted. Open and acknowledged incidents are retained.":
    "Alle behobenen technischen Fehler werden gelöscht. Offene und gesehene Fälle bleiben erhalten.",
  Incidents: "Fehlerfälle",
  "No incidents": "keine Fehlerfälle",
  "Incident location": "Stelle",
  Occurrences: "Vorkommen",
  "Last occurrence": "zuletzt",
  "Last tenant": "zuletzt bei Mandant",
  "Request ID": "Anfrage-ID",
  Origin: "Ursprung",
  "Mark in progress": "in Bearbeitung",
  "Mark resolved": "gelöst",
  IncidentStatus_open: "offen",
  IncidentStatus_acknowledged: "in Bearbeitung",
  IncidentStatus_resolved: "gelöst",
  "Failed to load incidents": "Fehlerfälle konnten nicht geladen werden.",
  "Failed to update incident": "Der Fehlerfall konnte nicht geändert werden.",
  "A connection is on hold": "Ein Zugang ist angehalten",
  "Connections are on hold": "Zugänge sind angehalten",
  TenantAccessCause_access: "Zugang abgelehnt oder abgelaufen",
  TenantAccessCause_funds: "Guthaben oder Tarif fehlt",
  TenantAccessCause_unreachable: "nicht erreichbar",
  TenantAccessCause_throttled: "vom Anbieter gedrosselt",
  TenantAccessCause_deterministic: "wird von uns geprüft",
  TenantAccessCause_internal: "wird von uns geprüft",
  since: "seit",
  Reconnect: "neu verbinden",
  "Check connection": "Verbindung prüfen",
  "Technical details copied": "Technische Details kopiert.",
  "Copying technical details is not available": "Technische Details konnten nicht kopiert werden.",
} as const;

export const sharedAdminFailureCircuitEn = {
  "Show resolved": "Show resolved",
  "Open system log": "Open system log",
  "Blocked failure sources": "Disruptions",
  "No blocked failure sources": "No disruptions",
  "Tenant access problems": "Tenant access",
  "No tenant access problems": "No connections on hold",
  "Failure class": "Cause",
  Responsible: "Responsible",
  "Next attempt": "Next attempt",
  "Check now": "Check now",
  "Check requested": "The next attempt is checked right away.",
  "Failed to check failure circuit": "The check could not be requested.",
  "Several tenants": "Several tenants",
  Responsibility_automatic: "Automatic",
  Responsibility_tenant: "Tenant",
  Responsibility_operator: "Operator",
  FailureCause_unreachable: "Unreachable",
  FailureCause_throttled: "Throttled",
  FailureCause_access: "Access",
  FailureCause_funds: "Credit",
  FailureCause_deterministic: "Reproducible",
  FailureCause_internal: "Our side",
  Failures: "Failures",
  "Suppressed attempts": "Suppressed attempts",
  "First failure": "First failure",
  "Last failure": "Last failure",
  "Blocked since": "Blocked since",
  "Blocked until": "Blocked until",
  "Blocked indefinitely": "Until released",
  Release: "Release",
  "Release block": "Release this block?",
  "Releasing a block does not restart anything":
    "Releasing a block does not restart anything: only the next regular run starts again.",
  "Failure circuit released": "Block released.",
  "Resolved incidents deleted": "Resolved incidents deleted.",
  FailureClass_hard: "Hard",
  FailureClass_system: "System",
  FailureClass_tenant_action: "Tenant matter",
  FailureClass_transient: "Transient",
  "Failed to load failure circuits": "Failed to load blocked failure sources.",
  "Failed to release failure circuit": "Failed to release the block.",
  "Failed to delete resolved incidents": "Failed to delete resolved incidents.",
  Problem: "Problem",
  "No details recorded": "No details recorded",
  "Error kind": "Error kind",
  Notification: "Operator notice",
  "Notification pending": "Pending",
  "Notification not applicable": "Not applicable",
  "Notification sent": "Sent",
  "Failure source": "Failure source",
  "Scope key": "Scope key",
  "Failure description": "Description",
  "Technical error": "Technical error",
  "Open tenant": "Open tenant",
  "Copy technical details": "Copy technical details",
  "Delete resolved incidents": "Delete resolved incidents",
  "Delete resolved incidents?": "Delete resolved incidents?",
  "All resolved incident records are deleted. Active incidents are retained and no source is restarted.":
    "All resolved incident records are deleted. Active incidents are retained and no source is restarted.",
  "All resolved technical incident records are deleted. Open and acknowledged incidents are retained.":
    "All resolved technical incident records are deleted. Open and acknowledged incidents are retained.",
  Incidents: "Incidents",
  "No incidents": "No incidents",
  "Incident location": "Location",
  Occurrences: "Occurrences",
  "Last occurrence": "Last occurrence",
  "Last tenant": "Last tenant",
  "Request ID": "Request ID",
  Origin: "Origin",
  "Mark in progress": "In progress",
  "Mark resolved": "Resolved",
  IncidentStatus_open: "Open",
  IncidentStatus_acknowledged: "In progress",
  IncidentStatus_resolved: "Resolved",
  "Failed to load incidents": "Failed to load incidents.",
  "Failed to update incident": "The incident could not be updated.",
  "A connection is on hold": "A connection is on hold",
  "Connections are on hold": "Connections are on hold",
  TenantAccessCause_access: "Access denied or expired",
  TenantAccessCause_funds: "Credit or plan missing",
  TenantAccessCause_unreachable: "Unreachable",
  TenantAccessCause_throttled: "Throttled by the provider",
  TenantAccessCause_deterministic: "Being checked by us",
  TenantAccessCause_internal: "Being checked by us",
  since: "since",
  Reconnect: "Reconnect",
  "Check connection": "Check connection",
  "Technical details copied": "Technical details copied.",
  "Copying technical details is not available": "Technical details could not be copied.",
} as const;

export const sharedAdminFailureCircuitTranslations = {
  de: sharedAdminFailureCircuitDe,
  en: sharedAdminFailureCircuitEn,
} as const;

export type SharedAdminFailureCircuitLang = keyof typeof sharedAdminFailureCircuitTranslations;
export type SharedAdminFailureCircuitKey = keyof typeof sharedAdminFailureCircuitDe;
